module.exports = __webpack_public_path__ + "img/add-car.bd568f9d.png";